export interface Discount {
  clicks: number,
  totalClicks: number,
  value: number,
  purchase: string,
  percent: string,
  code: string
}

const discounts: Discount[] = [
  {
    clicks: 1000, totalClicks: 1000, value: 1000, purchase: '5000', percent: '10%', code: 'bfpya'
  },
  {
    clicks: 1500, totalClicks: 2500, value: 1500, purchase: '7500', percent: '20%', code: 'bfpyb'
  },
  {
    clicks: 3000, totalClicks: 5500, value: 3000, purchase: '15 000', percent: '30%', code: 'bfpyc'
  }
]

export function needShowPromoCode(codeNumber: number, counter: number) {
  return discounts[codeNumber] && discounts[codeNumber].totalClicks <= counter
  //return (codeNumber < 1 && counter > 1000) || (codeNumber < 2 && counter > 2000) || (codeNumber < 3 && counter > 3000)
}

export function getPromoCode(codeNumber: number): Discount {
  return getNextPromoCode(codeNumber - 1)
}

export function getNextPromoCode(codeNumber: number): Discount {
  return discounts[codeNumber]
}

export function checkIsMaximumDiscount(discount: Discount): boolean {
  return discount.value === discounts[2].value
}

export function getCodeNumberByValue(value: number): number {
  return discounts.findIndex((el) => el.value === value)
}